(function () {
    angular.module('tradersyard').component('tyBoostButton', {
        // language=HTML
        template: `<a ng-href="{{$ctrl.boostPostUrl}}" class="ty-button ty-boost-button" ng-class="$ctrl.classMap[$ctrl.variant]" target="_blank">Boost Post <i class="fa fa-bolt"></i></a>`,
        bindings: {
            postId: '<',
            variant: '@?',
        },
        controller: BoostButtonCtrl,
    });

    BoostButtonCtrl.$inject = [];

    function BoostButtonCtrl() {
        var ctrl = this;

        ctrl.classMap = {
            small: 'small',
        };

        /**
         * Url to a Boost Post screen in SA
         * @type {string|null}
         */
        ctrl.boostPostUrl = null;
        ctrl.$onInit = $onInit;

        /**
         * @param {ng.IOnChangesObject} changes
         */
        function $onInit(changes) {
            ctrl.boostPostUrl = `/sa/posts/${ctrl.postId}/boost`;
            ctrl.variant = ctrl.variant || '';
        }
    }
})();
